<template>
    <div class="modal" :class="modalWidth">
        <div class="modal--body">
            <modal-header>{{ title }}</modal-header>
            <modal-content v-if="!error">{{ text }}</modal-content>
            <modal-content v-if="error">
                <card class="card--minify card--message error">
                    <card-content v-html="error" />
                </card>
            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button @click="this.$emit('confirmDialog')" :color="btnColor" v-if="!error">{{ confirm }}</form-button>
            </modal-actions>
        </div>
        <div class="modal--background" @click="this.$emit('closeDialog')"></div>
    </div>
</template>

<script>
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import Card from '@partfactory/Shared/Card/Card';
import CardContent from '@partfactory/Shared/Card/CardContent';
export default {
    name: 'ModalDialog',
    components: {CardContent, Card, FormButton, ModalActions, ModalContent, ModalHeader},
    props: {
        title: null,
        text: null,
        confirm: null,
        color: null,
        width: null,
        error: null,
    },
    computed: {
        modalWidth() {
            return this.width ? 'modal--' + this.width : '';
        },
        btnColor() {
            return this.color ? this.color : 'error';
        }
    },
    emit: ['closeDialog, confirmDialog'],
};
</script>
